
import Splide from '@splidejs/splide';
import { SplideLabels } from './splide-labels-component';

document.addEventListener( 'DOMContentLoaded', () => {
        const carousel = document.querySelectorAll('.splide');
        if (carousel.length > 0) {
                carousel.forEach((splide, i) => {
                        new Splide( splide).mount({
                                SplideLabels
                        });
                })
        }
} );
